import React, { useState, useEffect} from 'react';
import Title from '../../components/title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import SubTitle from '../../components/subTitle/SubTitle';
//import './EgresoDetalle.css';
import {BE_URL_2, httpGet } from '../../http';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { formatNumber, formatDateMin } from '../../misc/index';
 

const NotaContableDetalle = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {

        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(newEstado);
        
        setEstado(newEstado);

        if(!props.history.location.state.nota){
            props.history.push('/portal');
            return 0;
        }
        
        getNotaDetalle(props.history.location.state.nota);

    }, []);

    const getNotaDetalle = async (nota2) => {
        setNota({
            ...nota,
            loading: true
        });

        const companyId = sessionStorage.getItem('companyId');

        const proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        
        const detalles = await httpGet(BE_URL_2 + '/api/v1/egresos/detalle/' + nota2.rowid);
        const detalleContableReq = await httpGet(BE_URL_2 + '/api/v1/egresos/documento/detalle-contable/' + nota2.rowid);
        console.log('DETALLE', detalleContableReq);

        setNota({
            ...nota,
            encabezado: nota2,
            detalles: detalles.data,
            detalleContable: detalleContableReq.data.detalles,
            loading: false
        });
                
    }

    const [nota, setNota ] = useState(
        {
            encabezado: {
                tipoDoc: '',
                numeroDoc: '',
                fechaDoc: '',
                detalle: '',
                valor: 0,
                total_cr: 0,
                total_db: 0,
            },
            detalles: {
                detalles: [],
                totalDebito: 0,
                totalCredito: 0
            },
            detalleContable: [],
            loading: false,
            error: {},
            reg: 0
        }
    );

    const generarNotaDetallePdf = async () => {

        let newNota = {
            empresa: estado.empresa,
            proveedor: estado.proveedor,
            encabezado: nota.encabezado,
            detalles: nota.detalles,
            detalleContable: nota.detalleContable
        }

        props.history.push({ pathname: '/portal/nota-contable-pdf', state: { nota: newNota } });
    }

    return(
        <div className='page-container'>
            <Title>Detalle nota contable</Title>
            <div className='page-body'>
                <SubTitle>Empresa: {estado.empresa.razonSocial}</SubTitle>
                <SubTitle>Proveedor:</SubTitle>
                <div>
                    <div><span className='info-title'>N.I.T: </span><span>{ estado.proveedor.nit }</span></div>
                    <div><span className='info-title'>Razón social: </span><span>{ estado.proveedor.razonSocial }</span></div>
                </div>
                <br />
                <br />
                <SubTitle>Detalle de la nota</SubTitle>
                {nota.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
                :
                <>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>C. O.</th>
                                <th>DOCUMENTO</th>
                                <th>FECHA DEL DOCUMENTO</th>
                                <th>DETALLE</th>
                                <th>VALOR DEL DOCUMENTO</th>                                                        
                                <th>DEBITOS</th>
                                <th>CREDITOS</th>
                                <th>DESCARGAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{ nota.encabezado.idCo }</td>
                                <td>{ nota.encabezado.tipoDoc + '-' + nota.encabezado.numeroDoc }</td>
                                <td>{ formatDateMin( new Date(nota.encabezado.fechaDoc) ) }</td>
                                <td>{ nota.encabezado.notas }</td>
                                <td>${ formatNumber(nota.encabezado.total_cr) }</td>
                                <td>${ formatNumber(nota.encabezado.total_db) }</td>
                                <td>${ formatNumber(nota.encabezado.total_cr) }</td>
                                <td><div className='pdf-icon-container' onClick={generarNotaDetallePdf}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></div></td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <br />
                    <SubTitle>Movimiento contable</SubTitle>
                    <table className='info-table doc-table'>
                        <thead>
                            <tr>
                                <th>REG.</th>
                                <th>CODIGO CUENTA</th>
                                <th>DESCRIPCION CUENTA</th>
                                <th>CO</th>
                                <th>TERCERO</th>
                                <th>RAZON SOCIAL</th>
                                <th>DEBITOS</th>
                                <th>CREDITOS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                nota.detalles.detalles.map(
                                    (detalle, index) => {
                                        return(
                                            <tr key={index}>
                                                <td>{ (index + 1) }</td>
                                                <td>{ detalle.cuentaId }</td>
                                                <td>{ detalle.cuentaDescripcion }</td>
                                                <td>{ detalle.idCo }</td>
                                                <td>{ detalle.nit }</td>
                                                <td>{ detalle.razonSocial }</td>
                                                <td>${ formatNumber(detalle.valorDb) }</td>
                                                <td>${ formatNumber(detalle.valorCr) }</td>
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                    { nota.detalleContable.length > 0 &&
                        <>
                        <br />
                        <br />
                        <SubTitle>Detalle contable</SubTitle>
                        <table className='info-table doc-table'>
                            <thead>
                                <tr>
                                    <th>REG.</th>
                                    <th>AUXILIAR</th>
                                    <th>C.O.</th>
                                    <th>U.N.</th>
                                    <th>TERCERO</th>
                                    <th>DEBITOS</th>
                                    <th>CREDITOS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    nota.detalleContable.map(
                                        (detalle, index) => {
                                            return(
                                                <tr key={index}>
                                                    <td>{ (index + 1) }</td>
                                                    <td>{ detalle.cuentaId }</td>
                                                    <td>{ detalle.idCoMov }</td>
                                                    <td>{ detalle.idUN }</td>
                                                    <td>{ detalle.nit }</td>
                                                    <td>${ formatNumber(detalle.valorDb) }</td>
                                                    <td>${ formatNumber(detalle.valorCr) }</td>
                                                </tr>
                                            );
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                        </>
                    }
                </>
                }
            </div>
        </div>
    );
}

export default NotaContableDetalle;
